import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Programa } from 'src/app/core/programa';
import { Rotas } from 'src/app/core/rotas';
import { BaseService } from '../base/base.service';


@Injectable({
  providedIn: 'root'
})
export class ProgramaService extends BaseService<Programa> {

  constructor(http: HttpClient) {
    super(http, Rotas.PROGRAMAS);
  }

  getAllProgramasIntituicaoLogada() {
    return this.http.get(`${Rotas.PROGRAMAS}instituicao/logada`);
  }

  getAllCombo() {
    return this.http.get(`${Rotas.PROGRAMAS}dados/combo`);
  }

  getAllComboByContrato(idContrato: number) {
    return this.http.get(`${Rotas.PROGRAMAS}dados/combo/${idContrato}`);
  }
}
